/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";
export const VeiculoSCH = (perPage)=> {
    let filtro = new Filtro();
    filtro.perPage = perPage;
    filtro.fields = ['*'];
    filtro.addOrder('placa', 'asc');
  return filtro
};
